"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleRecipientType = exports.ScheduleUnit = exports.FileFormat = void 0;
var FileFormat;
(function (FileFormat) {
    FileFormat["PDF"] = "pdf";
    FileFormat["EXCEL"] = "excel";
})(FileFormat || (exports.FileFormat = FileFormat = {}));
var ScheduleRecipientType;
(function (ScheduleRecipientType) {
    ScheduleRecipientType["USER"] = "userOxygenId";
    ScheduleRecipientType["COMPANY"] = "companyOxygenId";
    ScheduleRecipientType["ROLE"] = "roleOxygenId";
    ScheduleRecipientType["EMAIL"] = "email";
})(ScheduleRecipientType || (exports.ScheduleRecipientType = ScheduleRecipientType = {}));
var ScheduleUnit;
(function (ScheduleUnit) {
    ScheduleUnit["WEEK"] = "week";
    ScheduleUnit["MONTH"] = "month";
})(ScheduleUnit || (exports.ScheduleUnit = ScheduleUnit = {}));
__exportStar(require("./config/types"), exports);
__exportStar(require("./notification/types"), exports);
__exportStar(require("./report/types"), exports);
__exportStar(require("./template/types"), exports);
__exportStar(require("./settings/types"), exports);
__exportStar(require("./schedule/types"), exports);
__exportStar(require("./serviceTemplates/types"), exports);
